import * as angular from 'angular';

import { ITabsController } from './tabs-directive';

class TabsPanelDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';

    readonly require = '^fcTabs';
    readonly template = `
        <div ng-transclude></div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(
        _scope: angular.IScope,
        element: JQuery,
        _attributes: angular.IAttributes,
        tabs: ITabsController
    ): void {
        tabs.registerPanel(element);
    }
}

const TabsPanelDirectiveFactory: angular.IDirectiveFactory = () => new TabsPanelDirective();

export { TabsPanelDirectiveFactory };
